export enum CordovaPlatformType {
  Ios = 'ios',
  Android = 'android',
  Browser = 'browser',
}
